// extracted by mini-css-extract-plugin
export default {"button":"Text-module--button--ZMRZX","text":"Text-module--text--xruKw"};